import Modal from 'react-responsive-modal';
import styles from './style.module.css';
import { useEffect, useState } from 'react';
import { FormRegisterDinamic } from './components/FormRegisterDinamic';
import { useNavigate } from 'react-router-dom';

interface IModalCallbackAlert {
  title: string;
  text: string;
  modalIsOpen: boolean;
  textBtnCancel?: string;
  textBtnAction?: string;
  habiliteLink?: boolean;
  showActions?: boolean;
  showForm?: boolean;
  logo?: string;
  toggleModal: () => void;
}

export function ModalCallbackAlert({
  modalIsOpen,
  toggleModal,
  text,
  title,
  textBtnAction,
  textBtnCancel,
  habiliteLink,
  logo,
  showActions,
  showForm,
}: IModalCallbackAlert) {
  const navigate = useNavigate();
  const [actionId, setActionId] = useState('');
  const [clientId, setClientId] = useState('');
  const [playerId, setPlayerId] = useState('');
  const [hostId, setHostId] = useState('');

  useEffect(() => {
    const actionId = sessionStorage.getItem('actionId');
    const clientId = sessionStorage.getItem('clientId');
    const playerId = sessionStorage.getItem('playerId');
    const hostId = sessionStorage.getItem('hostId');

    if (actionId) {
      setActionId(actionId);
    }

    if (clientId) {
      setClientId(clientId);
    }

    if (playerId) {
      setPlayerId(playerId);
    }

    if (hostId) {
      setHostId(hostId);
    }
  }, []);

  useEffect(() => {
    const isShowAlert = sessionStorage.getItem('isShowModalAlertCallback');

    if (!isShowAlert) {
      document.documentElement.addEventListener('mouseleave', activeMouseLeave);
    }
  }, []);

  const activeMouseLeave = () => {
    const isShowAlert = sessionStorage.getItem('isShowModalAlertCallback');
    if (!isShowAlert) {
      toggleModal();
    }
  };

  return (
    <>
      <Modal
        open={modalIsOpen}
        onClose={() => {
          toggleModal();
          sessionStorage.setItem('isShowModalAlertCallback', 'true');
        }}
        center
      >
        <div className={styles.contents}>
          {logo && (
            <>
              <div className="mb-5 d-flex justify-content-center">
                <img src={logo} width="50%" />
              </div>
            </>
          )}
          <h1 className="fw-semibold fs-4">{title}</h1>
          <p className="mt-3">{text}</p>
          <hr />
          {showForm && (
            <FormRegisterDinamic
              action={actionId}
              client={clientId}
              player={hostId}
            />
          )}
        </div>
        {showActions && (
          <div className={styles.contentBtn}>
            <button
              onClick={() => {
                toggleModal();
                sessionStorage.setItem('isShowModalAlertCallback', 'true');
              }}
              className={styles.btnBack}
              type="button"
            >
              {textBtnCancel ? textBtnCancel : 'Deixo passar'}
            </button>
            <button
              onClick={() => {
                toggleModal();
                if (habiliteLink) {
                  // location.href = `${location.protocol}//${
                  //   location.host
                  // }/register?action=${actionId}&client=${clientId}&player=${
                  //   hostId && hostId !== 'undefined' ? hostId : playerId
                  // }`;
                  navigate(
                    `/register?action=${actionId}&player=${playerId}&client=${clientId}`
                  );
                } else {
                  console.log('redirect unnabled');
                }
              }}
              className={styles.btnAgree}
              type="button"
            >
              {textBtnAction ? textBtnAction : 'Quero ganhar'}
            </button>
          </div>
        )}
      </Modal>
    </>
  );
}
